export default import.meta.ROLLDOWN_FILE_URL_g$olizMZuZSrwHhyt1dNbg